import axios from '@/http/axios';

export default {
  fetchList: (config: any = {}) => {
    return axios.get(`/business-credit-checks/`, config);
  },
  approve: (oid, config: any = {}) => {
    return axios.put(`/business-credit-checks/${oid}/approve`, config);
  },
  reject: (oid, config: any = {}) => {
    return axios.put(`/business-credit-checks/${oid}/reject`, config);
  },
  report: (oid) => {
    return axios.get(`/business-credit-checks/${oid}/report`, {
      responseType: 'arraybuffer',
    });
  },
};
